module.exports = {"name":"Zoznam škôl","icon":"<i class='material-icons'>school</i>","widget":[{"type":"school-list","head":["Hlavička","Popis"],"schemas":{"persons":"urn:mbry:schema:1:APIcoachsBaseData:v1"},"cols":[["baseData.name.v","test"],["clubAdress.city"],["clubAdress.street","p.clubAdress.houseNumber"]],"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/school-list/school-list.json
// module id = 391
// module chunks = 0